// Header
export const CHECK = "check";
export const COMMENT = "comment";
export const DOCUMENT_TYPE = "documentTypeId";
export const DOCUMENT_ID = "parkDocumentHeaderId";
export const POST_DOCUMENT_ID = "postDocumentHeaderId";
export const VENDOR_ID = "vendorId";
export const BANK_ACCOUNT = "bankAccountGlId";
export const POSTING_DATE = "postingDate";
export const ACCOUNT_NAME = "accountName";
export const PAYMENT_AMOUNT = "paymentAmount";
export const CHEQUE_NO = "chequeNo";
export const PAYMENT_DATE = "paymentDate";
export const BANK_CHARGES = "bankChargeAmount";
export const DEDUCTION_AMT = "deductionAmt";
export const PAYMENT_TERMS = "paymentTerm";
export const PAYMENT_METHOD = "paymentMethod";
export const PAYMENT_METHOD_ID = "paymentMethodId";
export const POSTING_YEAR = "postingYear";
export const POSTING_MONTH = "postingMonth";

export const TOTAL_PAYABLE = "totalPayable";
export const UNASSIGNED = "unassigned";

// line items
export const LINE_ITEMS = "lineItems";
export const INVOICE_DATE = "invoiceDate";
export const INVOICE_NO = "invoiceNumber";
export const INVOICE_REF = "invoiceRef";
export const DOC_NO = "postDocumentHeaderId";
export const DOC_TYPE = "documentType";
export const HEADER_TEXT = "headerText";
export const BASELINE_DATE = "baselineDate";
export const DUE_DATE = "dueDate";
export const PAY_BLOCK = "payBlock";
export const DRCR = "drCr";
export const INVOICE_AMT = "invoiceAmount";
export const APPROVED_AMT = "approvedAmount";
export const ORIGINAL_AMT = "originalAmt";
export const TARGET_VENDOR_SUBLEDGER_ID = "targetVendorSubledgerId";
export const PAYABLE_AMT = "payableAmount";
export const RESIDUAL = "residualAmount";

export const drcrOptions = [
  { label: "Dr", value: "DR" },
  { label: "Cr", value: "CR" },
];
